import { FcManager, FcPodiumWithSpeaker, FcPuzzle, FcReading, FcRules } from "react-icons/fc";


export const TeacherAnalyticsData = [
    {
        label: 'Total Students',
        value: 51,
        icon: <FcManager className="text-5xl md:text-6xl lg:text-7xl" />,
        color: '#7F49F2'
    },
    {
        label: 'Total Subjects',
        value: 8,
        icon: <FcReading className="text-5xl md:text-6xl lg:text-7xl" />,
        color: '#E9C030'
    },
    {
        label: 'Total Quizzes',
        value: 32,
        icon: <FcRules className="text-5xl md:text-6xl lg:text-7xl" />,
        color: '#EA794A'
    },
    {
        label: 'Total Games',
        value: 16,
        icon: <FcPuzzle className="text-5xl md:text-6xl lg:text-7xl" />,
        color: '#63CB82'
    },
    {
        label: 'Total Classess',
        value: 90,
        icon: <FcPodiumWithSpeaker className="text-5xl md:text-6xl lg:text-7xl" />,
        color: '#3BC6DF'
    },
];

export const PendingHomeworkData = [
    {
        image: 'https://i2-prod.belfastlive.co.uk/incoming/article26795951.ece/ALTERNATES/s615/0_RS18127_Jenny.jpg',
        name: 'Jenny Wilson',
        grade: 3,
        subject: 'Algebra',
        topic: 'Fraction',
        percentage: 65,
        action: 'Test',
    },
    {
        image: 'https://i2-prod.belfastlive.co.uk/incoming/article26795951.ece/ALTERNATES/s615/0_RS18127_Jenny.jpg',
        name: 'Jenny Wilson',
        grade: 3,
        subject: 'Algebra',
        topic: 'Fraction',
        percentage: 65,
        action: 'Quiz',
    },
    {
        image: 'https://i2-prod.belfastlive.co.uk/incoming/article26795951.ece/ALTERNATES/s615/0_RS18127_Jenny.jpg',
        name: 'Jenny Wilson',
        grade: 3,
        subject: 'Geometry',
        topic: 'Fraction',
        percentage: 65,
        action: 'Quiz',
    },
    {
        image: 'https://i2-prod.belfastlive.co.uk/incoming/article26795951.ece/ALTERNATES/s615/0_RS18127_Jenny.jpg',
        name: 'Jenny Wilson',
        grade: 3,
        subject: 'Algebra',
        topic: 'Fraction',
        percentage: 65,
        action: 'Games',
    },
];

export const UpcomingEventsData = [
    {
       meetingsName: 'Teacher Conference',
       startTime: '08:00 AM',
       endTime: '12:00 AM',
       date: '15-July',
       image: 'https://www.shutterstock.com/image-photo/speaker-giving-talk-on-corporate-600nw-481869205.jpg'

    },
    {
       meetingsName: 'Teacher Conference',
       startTime: '08:00 AM',
       endTime: '12:00 AM',
       date: '15-July',
       image: 'https://www.shutterstock.com/image-photo/speaker-giving-talk-on-corporate-600nw-481869205.jpg'

    },
    {
       meetingsName: 'Teacher Conference',
       startTime: '08:00 AM',
       endTime: '12:00 AM',
       date: '15-July',
       image: 'https://www.shutterstock.com/image-photo/speaker-giving-talk-on-corporate-600nw-481869205.jpg'

    },
    {
       meetingsName: 'Teacher Conference',
       startTime: '08:00 AM',
       endTime: '12:00 AM',
       date: '15-July',
       image: 'https://www.shutterstock.com/image-photo/speaker-giving-talk-on-corporate-600nw-481869205.jpg'

    },
    {
       meetingsName: 'Teacher Conference',
       startTime: '08:00 AM',
       endTime: '12:00 AM',
       date: '15-July',
       image: 'https://www.shutterstock.com/image-photo/speaker-giving-talk-on-corporate-600nw-481869205.jpg'

    },

];

export const lessonsData = [
    {
        subjectName: 'Pre-Algebra',
        topic: 'Multiplying decimals',
        startTime: '10:00 AM',
        endTime: '11:00 AM',
    },
    {
        subjectName: 'Geometry',
        topic: 'polygon Basics',
        startTime: '11:00 AM',
        endTime: '12:00 AM',
    },
    {
        subjectName: 'Algebra',
        topic: 'Equations and Inequalities',
        startTime: '10:00 AM',
        endTime: '11:00 AM',
    },
    {
        subjectName: 'Pre-Algebra',
        topic: 'Multiplying decimals',
        startTime: '10:00 AM',
        endTime: '11:00 AM',
    },
    {
        subjectName: 'Geometry',
        topic: 'polygon Basics',
        startTime: '11:00 AM',
        endTime: '12:00 AM',
    },
  
    {
        subjectName: 'Pre-Algebra',
        topic: 'Multiplying decimals',
        startTime: '10:00 AM',
        endTime: '11:00 AM',
    },
    
] 